import { defineInterface } from '@nzyme/ioc/Interface.js';
/**
 * Provides current country.
 */
export const CountryContext = defineInterface({
    name: 'CountryContext',
});
//# sourceMappingURL=CountryContext.js.map